module.exports = __webpack_public_path__ + "53fd48d46473e44cbf1a8024e56314bb.pdf";